import { Sparkles } from "lucide-react";
import { Reveal, Hud } from "./Reveal";
import { SectionStrip } from "./SectionStrip";

export const Proof = () => (
  <section id="proof" data-testid="proof-section" className="relative bg-cover bg-center" style={{ backgroundImage: "url(/assets/gen/texture-concrete.jpg)" }}>
    <div className="texture-overlay absolute inset-0" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <Hud>The Proof</Hud>
        <h2 className="mt-5 font-heading text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
          We Make It <span className="text-gold">Disappear.</span>
        </h2>
        <p className="mt-5 max-w-xl text-base font-medium capitalize leading-relaxed text-white/80 md:text-lg">
          Real Cobb County jobs, start to finish. Same space, same day — you won't believe it was ever full.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div data-testid="proof-combo-frame" className="shadow-hard-gold group mt-14 border-2 border-gold/50">
          <img
            src="/assets/before-after-driveway.webp"
            alt="Before and after of a driveway cleanout by GODSPEED Junk Hauling in Cobb County, GA"
            loading="lazy"
            decoding="async"
            className="block h-auto w-full"
          />
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div data-testid="proof-yard-frame" className="shadow-hard-gold group mt-8 border-2 border-gold/50">
          <img
            src="/assets/before-after-yard.webp"
            alt="Before and after of yard debris removal — logs, lumber, and brush cleared by GODSPEED Junk Hauling in Cobb County, GA"
            loading="lazy"
            decoding="async"
            className="block h-auto w-full"
          />
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div data-testid="proof-garage-frame" className="shadow-hard-gold group mt-8 border-2 border-gold/50">
          <img
            src="/assets/before-after-garage2.jpg"
            alt="Before and after of a garage cleanout — TV box, grill, and clutter hauled away by GODSPEED Junk Hauling in Kennesaw, GA"
            loading="lazy"
            decoding="async"
            className="block h-auto w-full"
          />
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <p data-testid="proof-caption" className="mt-10 font-body text-sm font-bold capitalize tracking-[0.1em] text-white/70 md:text-base">
          Every job ends swept, clear, and camera-ready — backed by the $10,000 Make It Right Guarantee.
        </p>
      </Reveal>
      <SectionStrip
        icon={Sparkles}
        title="Same Space. Same Day."
        text="Most cleanouts finish in a single visit — we sort, load, haul, and sweep before we roll, so the space is yours again by dinner."
        testid="proof-strip"
      />
    </div>
  </section>
);
